// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-bread-crumb{display:inline-block;vertical-align:top}", "",{"version":3,"sources":["webpack://./src/components/main/components/header-bar/custom-bread-crumb/custom-bread-crumb.less"],"names":[],"mappings":"AAAA,oBACE,oBAAA,CACA,kBACF","sourcesContent":[".custom-bread-crumb {\n  display: inline-block;\n  vertical-align: top;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
